import { NotificationScreen } from './NotificationScreen';

export default NotificationScreen;